import { Environment } from 'src/types/environment';

// eslint-disable-next-line no-magic-numbers
const CONFIGURATION_TIMEOUT_MS = 5000;

/** Loads the public CDK-generated endpoint before tenant discovery or authentication starts. */
export async function loadRuntimeConfiguration(environment: Environment, request: typeof fetch = fetch): Promise<Environment> {
  if (environment.configuration === 'local') { return environment; }

  const response = await request('/runtime-config.json', {
    cache: 'no-store', credentials: 'omit', signal: AbortSignal.timeout(CONFIGURATION_TIMEOUT_MS)
  });
  if (!response.ok) { throw new Error('The application configuration is unavailable.'); }
  const configuration: unknown = await response.json();
  if (!configuration || typeof configuration !== 'object' ||
      !('authDiscoveryUrl' in configuration) || typeof configuration.authDiscoveryUrl !== 'string') {
    throw new Error('The application discovery endpoint is not configured.');
  }

  const endpoint = new URL(configuration.authDiscoveryUrl);
  if (endpoint.protocol !== 'https:' || endpoint.username || endpoint.password || endpoint.search || endpoint.hash ||
      !endpoint.pathname.endsWith('/auth/discovery')) {
    throw new Error('The application discovery endpoint is invalid.');
  }
  return { ...environment, authDiscoveryUrl: endpoint.href };
}
